import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STEPS = [
  "Submit the form.",
  "Receive your initial assessment.",
  "Review the risks and opportunities.",
  "Decide whether to book a deeper workflow discussion.",
];

export default function ValidationNextSteps() {
  return (
    <section className="py-14 sm:py-16 bg-foreground text-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-4">
              Start with one workflow. Make the risk visible before AI scales.
            </h2>
            <p className="text-base opacity-70 leading-relaxed mb-6">
              The fastest way to make AI useful in a regulated lab is not to apply it everywhere. It is to evaluate one workflow carefully, define the controls, and move forward with proof instead of assumptions.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/Contact">
                <Button size="lg" className="w-full sm:w-auto gap-2 bg-background text-foreground hover:bg-background/90">
                  Book a Discovery Call
                  <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
          <div>
            <p className="text-sm font-semibold opacity-60 uppercase tracking-wider mb-5">What happens next</p>
            <p className="text-sm opacity-70 leading-relaxed mb-6">
              After submission, your lab receives a practical AI-readiness readout tied to the workflow you described. If the use case looks promising, the next step is usually a focused conversation about one high-friction workflow rather than a broad platform rollout.
            </p>
            <ol className="space-y-3">
              {STEPS.map((s, i) => (
                <li key={s} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full border border-background/30 text-background text-xs font-bold flex items-center justify-center shrink-0">
                    {i + 1}
                  </span>
                  <span className="text-sm opacity-80">{s}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}